import Button from 'common/components/Button'
import Image from 'common/components/Image'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import { mediaflexCdn } from 'lib/cdn'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Section = styled.section`
  display: flex;
  justify-content: center;
  padding: 40px 24px;
`

const Card = styled.div`
  width: ${theme.layout.containerWidth};
  max-width: 1180px;
  background: linear-gradient(135deg, #042a5b, #0a1e4c);
  border-radius: 28px;
  padding: 48px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
  color: ${theme.colors.white};
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 32px;
  }
`

const Label = styled(Typography)`
  ${theme.typography.rlabel}
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${theme.colors.orange};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Headline = styled(Typography)`
  font-size: 36px;
  line-height: 1.2;
  font-weight: 700;
`

const Description = styled(Typography)`
  ${theme.typography.rparagraph}
  max-width: 420px;
  color: rgba(255, 255, 255, 0.8);
`

const ImagePanel = styled.div`
  position: relative;
  margin: 0 64px;
  border-radius: 24px;
  min-height: 320px;
  background: url('${mediaflexCdn(
      '/f=auto,w=900/assets/img/new-services-item.png',
    )}')
    center/contain no-repeat;
`

const ProductTag = styled.div`
  width: 100px;
  height: 83px;
  position: absolute;
  top: 16px;
  left: 50px;
  transform: translate(-50%, 0);
  background: url('${mediaflexCdn(
      '/f=auto,w=150/assets/img/new-services-value.png',
    )}')
    center/cover no-repeat;
  color: ${theme.colors.white};
  border-radius: 16px;
  padding: 8px 16px;
  font-weight: 600;
`

const LogosStack = styled.div`
  position: absolute;
  right: 50px;
  top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 40px;
  transform: translate(65%, 0);
  @media (max-width: 768px) {
    position: static;
    transform: none;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
  }
`

const LogoFrame = styled.div`
  background: ${theme.colors.white};
  width: 58px;
  height: 38px;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledImage = styled(Image)`
  width: 64px;
  height: 20px;
  object-fit: scale-down;
`

const LearnButton = styled(Button)`
  width: fit-content;
  border-radius: 999px;
`

function ServicesPromoSection(): JSX.Element {
  const { t } = useTranslation('home')
  const handleLearnMore = () => {
    window.open(`${WEB_DESKTOP_RALALI_URL}/grow`, '_blank')
  }

  return (
    <Section>
      <Card>
        <Content>
          <Label type="rlabel">{t('SERVICES_PROMO_LABEL')}</Label>
          <Headline type="bh1" color="white">
            {t('SERVICES_PROMO_TITLE')}
          </Headline>
          <Description>{t('SERVICES_PROMO_DESC')}</Description>
          <LearnButton
            color="secondary"
            type="button"
            onClick={handleLearnMore}
          >
            {t('SERVICES_PROMO_BUTTON')}
          </LearnButton>
        </Content>
        <Content>
          <ImagePanel>
            <ProductTag />
            <LogosStack>
              <LogoFrame>
                <StyledImage
                  src={mediaflexCdn(
                    '/f=auto,w=350/assets/img/logo/shopee-logo.png',
                  )}
                  alt="Shopee"
                />
              </LogoFrame>
              <LogoFrame>
                <StyledImage
                  src={mediaflexCdn(
                    '/f=auto,w=350/assets/img/logo/tiktok-shop-logo.png',
                  )}
                  alt="TikTok Shop"
                />
              </LogoFrame>
              <LogoFrame>
                <StyledImage
                  src={mediaflexCdn(
                    '/f=auto,w=350/assets/img/ralali_logo-new.svg',
                  )}
                  alt="Ralali.com"
                />
              </LogoFrame>
            </LogosStack>
          </ImagePanel>
        </Content>
      </Card>
    </Section>
  )
}

export default ServicesPromoSection
